export default __webpack_public_path__ + "static/media/tk-45.c3d0ef5c.svg";